import { PureComponent, ReactNode } from 'react';

import packageInfo from '../../package.json';
import { initApiRequest } from '../libs/ApiRequest/ApiRequest';

import { AppContextProvider } from './AppContext.context';
import { AppContextProps, AppContextState } from './AppContext.types';

export class AppContextComponent extends PureComponent<AppContextProps, AppContextState> {
  constructor(props: AppContextProps) {
    super(props);
    initApiRequest(props.config);

    this.state = {
      config: props.config,
      appVersion: packageInfo.version,
    };
  }

  public render(): ReactNode {
    const { children } = this.props;

    return (
      <AppContextProvider
        value={{
          ...this.state,
        }}
      >
        {children}
      </AppContextProvider>
    );
  }
}
